import { render, staticRenderFns } from "./_token.vue?vue&type=template&id=504273f2&scoped=true"
import script from "./_token.vue?vue&type=script&lang=js"
export * from "./_token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504273f2",
  null
  
)

export default component.exports